import type * as maplibregl from "maplibre-gl";

/**
 * Taille des textes par paliers de zoom, doublée d'un palier au suivant comme la forme qu'ils
 * remplissent : MapLibre l'interpole à chaque image, sans recalcul pendant un zoom. `sizeAtZoom0`
 * vient de `shapesTextToGeoJSON`.
 *
 * Une tuile ne retient la taille qu'aux deux paliers qui encadrent son zoom et le suivant, et la
 * fige au-delà. Or MapLibre affiche encore l'ancienne tuile le temps de préparer la nouvelle : des
 * paliers entiers figeraient les textes, trop grands, dès qu'on dézoome. Décalés de
 * `SHAPE_TEXT_SIZE_STOP_OFFSET`, ils couvrent 0,85 zoom sous la tuile. Le plafond de chaque palier
 * reste sous les 255 px que MapLibre sait stocker.
 */
const SHAPE_TEXT_SIZE_MAX_ZOOM = 24;
export const SHAPE_TEXT_SIZE_STOP_OFFSET = 0.15;
export const SHAPE_TEXT_SIZE_STOP_MAX_PX = 250;
export const SHAPE_TEXT_SIZE_EXPRESSION = [
  "interpolate",
  ["exponential", 2],
  ["zoom"],
  ...Array.from({ length: SHAPE_TEXT_SIZE_MAX_ZOOM + 2 }, (_, index) => {
    const zoom = index - 1 + SHAPE_TEXT_SIZE_STOP_OFFSET;
    return [zoom, ["coalesce", ["get", "fixedSize"], ["min", SHAPE_TEXT_SIZE_STOP_MAX_PX, ["*", ["get", "sizeAtZoom0"], 2 ** zoom]]]];
  }).flat(),
] as unknown as maplibregl.ExpressionSpecification;
